/**@typedef {Object<string, boolean>} WidgetState*/

import _ from "lodash";
import { ADD_WIDGET, CHANGE_WIDGET_STATUS, REMOVE_WIDGET } from "redux/actions/widgetActions";

/**
 *
 * @param {WidgetState} state
 * @param {string} action
 * @returns {WidgetState}
 */
const widgets = (state = {}, action) => {
    switch (action.type) {
        case ADD_WIDGET: {
            const newState = _.cloneDeep(state);

            newState[action.widget.type] = {
                ...newState[action.widget.type],
                [action.widget.id]: false,
            };

            return newState;
        }

        case REMOVE_WIDGET: {
            const newState = _.cloneDeep(state);

            if (action.id && newState[action.widgetType]) {
                delete newState[action.widgetType][action.id];
            } else {
                delete newState[action.widgetType];
            }

            return newState;
        }

        case CHANGE_WIDGET_STATUS: {
            const newState = _.cloneDeep(state);

            newState[action.widget.type] = {
                ...newState[action.widget.type],
                [action.widget.id]: action.status,
            };

            return newState;
        }

        default:
            return state;
    }
};

export default widgets;
